import { EddStatus, EddStatusType } from "../types/edd.types";

export type StatusContentConfig = {
  headingText: string;
  subheadingText: string;
  actionButtonText: string;
};

export type StatusDisplayConfig = {
  iconName: string;
  accentColor: string;
  statusLabel: string;
};

export type InfoBoxConfig = {
  bg: string;
  icon: string;
  iconColor: string;
  textColor: string;
};

export const STATUS_DISPLAY_CONFIG: Partial<
  Record<EddStatusType, StatusDisplayConfig>
> = {
  [EddStatus.UNINITIATED]: {
    iconName: "Clock",
    accentColor: "#3b3b3b",
    statusLabel: "Takes 7 days to process"
  },
  [EddStatus.INITIATED]: {
    iconName: "Clock",
    accentColor: "#3b3b3b",
    statusLabel: "Submission Incomplete"
  },
  [EddStatus.VERIFICATION_IN_PROGRESS]: {
    iconName: "HourglassHigh",
    accentColor: "#6424C5",
    statusLabel: "Verification in progress"
  },
  [EddStatus.RESUBMISSION_REQUESTED]: {
    iconName: "WarningCircle",
    accentColor: "#E8584B",
    statusLabel: "Action Required"
  },
  [EddStatus.APPROVED]: {
    iconName: "CheckCircle",
    accentColor: "#219653",
    statusLabel: "Verified"
  },
  [EddStatus.REJECTED]: {
    iconName: "WarningCircle",
    accentColor: "#E8584B",
    statusLabel: "Rejected"
  }
};

export const STATUS_CONTENT_CONFIG: Partial<
  Record<EddStatusType, StatusContentConfig>
> = {
  [EddStatus.UNINITIATED]: {
    headingText: "Upgrade Transaction Limits",
    subheadingText: "Complete due diligence",
    actionButtonText: "Fill Due Diligence Form"
  },
  [EddStatus.INITIATED]: {
    headingText: "Upgrade Transaction Limits",
    subheadingText: "Continue due diligence",
    actionButtonText: "Continue Your Progress"
  },
  [EddStatus.RESUBMISSION_REQUESTED]: {
    headingText: "Further Action Required",
    subheadingText:
      "Our team has added feedback on your submission. Please review and resubmit any requested information",
    actionButtonText: "Review Feedback"
  },
  [EddStatus.VERIFICATION_IN_PROGRESS]: {
    headingText: "Review Pending",
    subheadingText: "Your submission has been received and is being reviewed",
    actionButtonText: ""
  },
  [EddStatus.APPROVED]: {
    headingText: "Limit Upgrade Request Approved",
    subheadingText: "",
    actionButtonText: "Request for Further Limit Upgrade"
  },
  [EddStatus.REJECTED]: {
    headingText: "Limit Upgrade Request Rejected",
    subheadingText: "",
    actionButtonText: ""
  }
};

export const STATUS_INFO_BOX_CONFIG: Partial<
  Record<EddStatusType, InfoBoxConfig>
> = {
  [EddStatus.REJECTED]: {
    bg: "bg-red-50 border border-red-200",
    icon: "WarningCircle",
    iconColor: "#E8584B",
    textColor: "text-red-900"
  },
  [EddStatus.APPROVED]: {
    bg: "bg-green-50 border border-green-200",
    icon: "CheckCircle",
    iconColor: "#219653",
    textColor: "text-green-900"
  },
  [EddStatus.VERIFICATION_IN_PROGRESS]: {
    bg: "bg-blue-50 border border-blue-200",
    icon: "Info",
    iconColor: "#2563EB",
    textColor: "text-blue-900"
  },
  [EddStatus.RESUBMISSION_REQUESTED]: {
    bg: "bg-red-50 border border-red-200",
    icon: "WarningCircle",
    iconColor: "#E8584B",
    textColor: "text-red-900"
  },
  [EddStatus.INITIATED]: {
    bg: "bg-blue-50 border border-blue-200",
    icon: "Info",
    iconColor: "#2563EB",
    textColor: "text-blue-900"
  },
  [EddStatus.UNINITIATED]: {
    bg: "bg-blue-50 border border-blue-200",
    icon: "Info",
    iconColor: "#2563EB",
    textColor: "text-blue-900"
  }
};
